module.exports = __webpack_public_path__ + "static/media/logout.f8feb75a.svg";